import React, { Component } from "react";
import AppContext from "../../../contexts/AppContext";

export class Testimonial extends Component {
    
	constructor(props) {
        super(props);
    }
	
	render() {
        return (
            <div className="card p-4 bg-white">
			    <p>"{this.props.text}"</p>
				{/*<div className="like d-flex align-items-center justify-content-end"><img className="mr-2" src="/images/like.svg" alt="like"/>53</div>*/}
				<div className="card-top d-flex align-items-center mt-3">
				    <img className="w-auto" src={`/images/${this.props.image}`} alt="image" width="40" height="40"/>
					<div className="ml-3">
					    <h4 className="mb-0">{this.props.name}</h4>
					    <p>{this.props.title}</p>
					</div>
				</div>
			</div>
		);
        
    }
}

Testimonial.contextType = AppContext;
export default Testimonial;



// WEBPACK FOOTER //
// ./src/components/general/include/Testimonial.js